var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"large-bold-text card-text"},[_vm._v(_vm._s(_vm.fullName()))]),_c('p',{staticClass:"small-bold-text card-text"},[_vm._v(_vm._s(_vm.teacher.email))])])}
var staticRenderFns = []

export { render, staticRenderFns }